<h4 class="mb-3 title text-center"><strong> Share your event!</strong></h4>

<div [ngClass]="{ hide: barcodeMode || selfServicesMode, unhide: !barcodeMode && !selfServicesMode }" [ngStyle]="{ 'max-height': personas.length > 1 ? '500px' : 'auto' }">
  <div [ngClass]="{ content: !dialogMode }">
    <div class="d-flex justify-content-center flex-wrap">
      <ng-container *ngFor="let persona of personas">
        <ngx-sharable-card
          (setSelfRegistrationPersona)="setClickedPersona($event)"
          class="p-2"
          [persona]="persona"
          [eventSlug]="event.slug"
          [eventId]="event.id"
          (barcodeClickEmitted)="showBarcodeContent($event)"
          (selfServicesClickEmitted)="showSelfServicesContent($event)"
          (landingPageClickEmitted)="openLandingPage($event)"
        ></ngx-sharable-card>
      </ng-container>
    </div>
  </div>

  <div class="row">
    <div class="col-12 text-center mb-3">
      <button [ngClass]="{ 'my-5': !dialogMode, 'mt-5': dialogMode }" type="button" role="button" nbButton status="basic" (click)="dismiss()">Close</button>
    </div>
  </div>
</div>

<div [ngClass]="{ hide: !barcodeMode, unhide: barcodeMode, content: !dialogMode }">
  <button ghost nbButton status="primary" class="position-absolute back-button" (click)="switchBarcodeMode()"><mat-icon>arrow_left</mat-icon>Back</button>
  <div class="d-flex flex-column align-content-center flex-wrap">
    <img [src]="barcodeLink" alt="Registration QR Code" class="qrcode" />
    <a class="align-self-center mt-2 mb-1" target="_self" (click)="download()" [download]="event.name + ' - ' + barcodePersona + ' QR Code.png'">Download QR code</a>
  </div>
</div>

<div [ngClass]="{ hide: !selfServicesMode, unhide: selfServicesMode, content: !dialogMode, 'py-5': true }">
  <button ghost nbButton status="primary" class="position-absolute back-button" (click)="switchSelfServicesMode()"><mat-icon>arrow_left</mat-icon>Back</button>
  <div class="d-flex">
    <div class="col align-items-center justify-content-center d-flex">
      <a *ngIf="!allowSelfRegisteration()" class="card mx-2 w-100 p-5" [nbTooltip]="tooltip">
        <div class="d-flex justify-content-center">
          <mat-icon>app_registration</mat-icon>
        </div>
        <div class="align-items-center d-flex form-control-lg justify-content-center">Self Registration & Printing</div>
      </a>

      <a *ngIf="allowSelfRegisteration()" class="card mx-2 w-100 p-5" (click)="redirect('SELF_REG')">
        <div class="d-flex justify-content-center">
          <mat-icon>app_registration</mat-icon>
        </div>
        <div class="align-items-center d-flex form-control-lg justify-content-center">Self Registration & Printing</div>
      </a>
    </div>

    <div class="col justify-content-center align-items-center">
      <a class="card w-100 mx-2 p-5" (click)="redirect('SELF_PRNT')">
        <div class="d-flex justify-content-center">
          <mat-icon>print</mat-icon>
        </div>
        <div class="align-items-center d-flex form-control-lg justify-content-center">Self Printing only</div>
      </a>
    </div>
  </div>
</div>
